import { compact, difference } from 'lodash';

import { UpdateHouseholdInput } from '@/types/schema';

export interface SelectClientsFormShape {
  integrationClientIds: string[];
}

export function toUpdateHouseholdInput(
  current: SelectClientsFormShape,
  baselineClientIds: readonly (string | undefined)[] | undefined
): UpdateHouseholdInput {
  const baseline = compact(baselineClientIds);
  const selected = current.integrationClientIds;

  const toAdd = difference(selected, baseline);
  const toRemove = difference(baseline, selected);

  return {
    ...(toAdd.length ? { addIntegrationClientIDs: toAdd } : {}),
    ...(toRemove.length ? { removeIntegrationClientIDs: toRemove } : {}),
  };
}

export function hasClientChanges(input: UpdateHouseholdInput): boolean {
  return Boolean(
    input.addIntegrationClientIDs?.length ||
      input.removeIntegrationClientIDs?.length
  );
}
